import FJPreviewInfo from '../view/FJPreviewInfo.jsx';
import { useCallback } from 'react';
import FJActionModal from '../../../../redux/action/FJActionModal.js';
import FJActionCommon from '../../../../redux/action/FJActionCommon.js';
import { useDispatch, useSelector } from 'react-redux';
import FJActionCommunity from '../../../../redux/action/FJActionCommunity.js';
import FJUtil from '../../../../util/FJUtil.js';
import FJDropDownManager from '../../../../common/js/FJDropDownManager.js';
import PropTypes from 'prop-types';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage.js';
import FJAIToolUtil from '../../../../util/FJAIToolUtil.js';
import { PUBLISH_TYPE } from '../../../../config/dataConfig/FJCommunityData.js';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJConstant from '../../../../constants/FJConstant.js';

const FJPreviewInfoContainer = ({ onDelete }) => {
    const dispatch = useDispatch();
    const detailsPreviewModalData = useSelector(state => state.modals.detailsPreviewModalData);
    const { data = {} } = detailsPreviewModalData;
    const { id, shareKey, privacyStatus } = data;
    const videoEffectStyleList = useSelector(state => state.AIVideoGenerator.styleList);

    const _closeModal = useCallback(() => {
        dispatch(FJActionModal.hideDetailsPreviewModalDataAction());
    }, [dispatch]);

    const _onDownload = () => {
        dispatch(FJActionCommunity.multiDownloadAction([data]));
    };

    const _shareToSociety = type => {
        const __share = () => {
            if (shareKey) {
                const shareLink = FJUtil.getShareLink(shareKey);
                shareLink && FJUtil.shareToSociety(type, shareLink);
            } else {
                dispatch(FJActionModal.shareToSocietyAction(id, type));
            }
        };
        if (privacyStatus && privacyStatus === PUBLISH_TYPE.PRIVATE) {
            dispatch(
                FJActionModal.showWarningModalAction({
                    title: FJLocalStore._('set-to-public'),
                    content: FJLocalStore._('this-creation-is-currently-private-sharing-it-will-make-it-public'),
                    footerDates: [
                        {
                            btnType: FJConstant.WARNING,
                            btnText: FJLocalStore._('continue'),
                            btnCallback: async () => {
                                const value = PUBLISH_TYPE.ONLY_PUBLIC;
                                dispatch(
                                    FJActionCommunity.onShareSettingClickAction(
                                        data,
                                        value,
                                        bool => {
                                            if (bool) {
                                                __share();
                                                dispatch(
                                                    FJActionModal.showDetailsPreviewModalDataAction({
                                                        data: { ...data, privacyStatus: value },
                                                    }),
                                                );
                                                if (!data?.workType) {
                                                    dispatch(
                                                        FJActionCommon.updateHistoryListCommunityInfoAction(id, {
                                                            privacyStatus: value,
                                                        }),
                                                    );
                                                }
                                            }
                                        },
                                        { ignoreMessage: true },
                                    ),
                                );
                            },
                        },
                        {
                            btnType: FJConstant.CANCEL,
                            btnText: FJLocalStore._('cancel'),
                            btnCallback: null,
                        },
                    ],
                }),
            );
        } else {
            __share();
        }
    };

    const _onEdit = useCallback(() => {
        _closeModal();
        if (data?.workType) {
            dispatch(FJActionCommunity.onRecreateClickAction(data, true));
        } else {
            dispatch(FJActionCommon.onRecreateAction(data));
            FJDropDownManager.hideAll();
        }
    }, [dispatch, data, _closeModal]);

    const _onLike = isLike => {
        dispatch(
            FJActionCommunity.onLikeClickAction(data, isLike, {
                isPreview: true,
                callback: bool => {
                    if (bool) {
                        const oldLikeNum = data?.likeNum || 0;
                        const newNumber = isLike ? oldLikeNum + 1 : oldLikeNum - 1;
                        dispatch(
                            FJActionModal.showDetailsPreviewModalDataAction({
                                data: { ...data, isLike: isLike, likeNum: newNumber },
                            }),
                        );
                        if (!data?.workType) {
                            dispatch(
                                FJActionCommon.updateHistoryListCommunityInfoAction(id, {
                                    isLike: isLike,
                                    likeNum: newNumber,
                                }),
                            );
                        }
                    }
                },
            }),
        );
    };

    const _onPrivacySettingChange = (value, callback) => {
        dispatch(
            FJActionCommunity.onShareSettingClickAction(data, value, bool => {
                callback(bool);
                if (bool) {
                    dispatch(
                        FJActionModal.showDetailsPreviewModalDataAction({
                            data: { ...data, privacyStatus: value },
                        }),
                    );
                    if (!data?.workType) {
                        dispatch(
                            FJActionCommon.updateHistoryListCommunityInfoAction(id, {
                                privacyStatus: value,
                            }),
                        );
                    }
                }
            }),
        );
    };

    const _onRecreate = () => {
        dispatch(FJActionCommunity.onRecreateClickAction(data, true));
    };

    const _onReport = () => {
        if (!FJUtil.isLogin()) {
            FJUtil.anonymousSignUp();
            return;
        }
        FJDropDownManager.hideAll();
        dispatch(FJActionModal.showReportModalAction({ shareKey: data.shareKey, uid: data.uid }));
    };
    const _addToMedia = () => {
        let url = data.imgUrl;
        if (FJAIToolUtil.getVideoAppTypeList().includes(data.appType)) url = data.videoUrl;
        else if (data.isAudioGenerator) url = data.audioUrl;
        dispatch(FJActionEditPage.addToMediaLibraryAction(url, { from: 'generate' }));
    };
    return (
        <FJPreviewInfo
            onDownload={_onDownload}
            shareToSociety={_shareToSociety}
            onEdit={_onEdit}
            data={data}
            videoEffectStyleList={videoEffectStyleList}
            onDelete={onDelete}
            onLike={_onLike}
            onPrivacySettingChange={_onPrivacySettingChange}
            onRecreate={_onRecreate}
            onReport={_onReport}
            onAddToMedia={_addToMedia}
        />
    );
};

FJPreviewInfoContainer.propTypes = {
    onDelete: PropTypes.func,
};

export default FJPreviewInfoContainer;
